export default {
  SET_NSR_RESULTS (state, nsrResults) {
    state.nsrResults = nsrResults
  }
}
